import { Select, pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledSelect = styled(Select) `
  width: ${pxToRem(70)};
`;
